import * as React from 'react';

export const LogoTikTok = (props) => (
  <svg
    width="41"
    height="43"
    viewBox="0 0 41 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1771_1012)">
      <path
        d="M40.3992 17.6464C36.5186 17.6551 32.7332 16.5288 29.5777 14.4267V29.0873C29.5766 31.8026 28.6848 34.4529 27.0216 36.6838C25.3583 38.9147 23.0028 40.6199 20.2701 41.5713C17.5374 42.5227 14.5578 42.675 11.7295 42.0079C8.9013 41.3408 6.35932 39.886 4.4435 37.838C2.52767 35.7901 1.32932 33.2467 1.00867 30.5478C0.688028 27.849 1.26038 25.1233 2.64919 22.7354C4.03799 20.3474 6.17707 18.4109 8.78038 17.1849C11.3837 15.9589 14.3271 15.5017 17.2172 15.8746V23.2483C15.8947 22.8612 14.4746 22.8729 13.1597 23.2817C11.8447 23.6905 10.7022 24.4755 9.89526 25.5246C9.08832 26.5737 8.65822 27.8333 8.66639 29.1235C8.67455 30.4137 9.12056 31.6685 9.94073 32.7087C10.7609 33.7489 11.9133 34.5214 13.2333 34.9157C14.5533 35.3101 15.9735 35.3061 17.291 34.9045C18.6084 34.5029 19.7559 33.7242 20.5694 32.6795C21.383 31.6348 21.821 30.3775 21.821 29.0873V0.427246H29.5777C29.5723 1.03685 29.6272 1.64563 29.7416 2.24588C30.0112 3.58584 30.5716 4.86055 31.3887 5.99203C32.2057 7.12351 33.2622 8.08797 34.4935 8.82643C36.2453 9.90439 38.2991 10.4789 40.3992 10.4785V17.6464Z"
        fill="url(#paint0_linear_1771_1012)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1771_1012"
        x1="0.921874"
        y1="5.29421"
        x2="41.2837"
        y2="6.28219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56C573" />
        <stop offset="1" stopColor="#5BC0AC" />
      </linearGradient>
      <clipPath id="clip0_1771_1012">
        <rect
          width="39.4888"
          height="42"
          fill="white"
          transform="translate(0.910156 0.427246)"
        />
      </clipPath>
    </defs>
  </svg>
);
